import { Injectable } from '@angular/core';
import { MIN_SECTOR_DIMENSIONS } from '../../constants';
import { IElementDims, ISeatsPlan } from '../../interfaces';
import { CreatorStateService } from './CreatorStateService';

@Injectable({
  providedIn: 'root'
})
export class SectorService {

  public recalculateSectorDimensions(recalculateForCashAndBooking = false, seatsPlan?: ISeatsPlan): void {
    let seatsPlanToRecalculate = seatsPlan || CreatorStateService.seatsPlan;

    if (seatsPlanToRecalculate.backgroundImageId) {
      return;
    }

    let x = 0;
    let y = 0;

    for (const element of seatsPlanToRecalculate.baseElements) {
      if (recalculateForCashAndBooking ? element.x > x : element.webX > x) {
        x = recalculateForCashAndBooking ? element.x + element.w : element.webX + element.w;
      }

      if (recalculateForCashAndBooking ? element.y > y : element.webY > y) {
        y = recalculateForCashAndBooking ? element.y + element.h : element.webY + element.h;
      }
    }

    for (const seat of seatsPlanToRecalculate.seats) {
      if (recalculateForCashAndBooking ? seat.sectorElement.x > x : seat.sectorElement.webX > x) {
        x = recalculateForCashAndBooking ? seat.sectorElement.x + seat.sectorElement.w : seat.sectorElement.webX + seat.sectorElement.w;
      }

      if (recalculateForCashAndBooking ? seat.sectorElement.y > y : seat.sectorElement.webY > y) {
        y = recalculateForCashAndBooking ? seat.sectorElement.y + seat.sectorElement.h : seat.sectorElement.webY + seat.sectorElement.h;
      }
    }

    for (const sector of seatsPlanToRecalculate.sectors) {
      if (recalculateForCashAndBooking ? sector.x > x : sector.webX > x) {
        x = recalculateForCashAndBooking ? sector.x + sector.w : sector.webX + sector.w;
      }

      if (recalculateForCashAndBooking ? sector.y > y : sector.webY > y) {
        y = recalculateForCashAndBooking ? sector.y + sector.h : sector.webY + sector.h;
      }
    }

    if (
      seatsPlanToRecalculate.baseElements.length === 0 &&
      seatsPlanToRecalculate.seats.length === 0 &&
      seatsPlanToRecalculate.sectors.length === 0
    ) {
      x = 0;
      y = 0;
    } else if (recalculateForCashAndBooking) {
      x += 100;
      y += 100;
    }

    if (
      x !== (recalculateForCashAndBooking ? seatsPlanToRecalculate.w : seatsPlanToRecalculate.webW) ||
      y !== (recalculateForCashAndBooking ? seatsPlanToRecalculate.h : seatsPlanToRecalculate.webH)) {
      if (recalculateForCashAndBooking) {
        seatsPlanToRecalculate.w = x < MIN_SECTOR_DIMENSIONS.w ? MIN_SECTOR_DIMENSIONS.w : Math.ceil(x);
        seatsPlanToRecalculate.h = y < MIN_SECTOR_DIMENSIONS.h ? MIN_SECTOR_DIMENSIONS.h : Math.ceil(y);
      } else {
        seatsPlanToRecalculate.webW = x < MIN_SECTOR_DIMENSIONS.w ? MIN_SECTOR_DIMENSIONS.w : Math.ceil(x);
        seatsPlanToRecalculate.webH = y < MIN_SECTOR_DIMENSIONS.h ? MIN_SECTOR_DIMENSIONS.h : Math.ceil(y);
      }
    }

    if (seatsPlanToRecalculate.id === CreatorStateService.seatsPlan.id) {
      CreatorStateService.seatsPlan = { ...CreatorStateService.seatsPlan };
    }
  }

  public checkIsEdgeElement(data: IElementDims): boolean {
    if (!data) {
      return false;
    }

    return data.webX + data.w >= CreatorStateService.seatsPlan.w || data.webY + data.h >= CreatorStateService.seatsPlan.h;
  }
}

